// плагины общего назначения
import   './common-plugins/juts-common-jquery-plugins.js';
import   './common-plugins/juts-common-jquery-ui-plugins.js';
import   './common-plugins/parentCloser.js'; 
import   './common-plugins/replaceInAttributes.js';

// Вложенные формы (группы полей)
import   './nested-forms/fromFiledsGroupAdderFromHiddenTemplate.js';
import   './nested-forms/parentInParentContainerDublicator.js';

// Работа с формами
import   './forms/isInputsEmpty.js'; // определяет что все потомки-инпуты условно "пусты"
import   './forms/getInputType.js'; // определяем тип